$(function($) {
    "use strict";

    $('.mediaslide').each(function() {
        var $element = $(this);

        var slides = $element.find('.swiper-slide').length;
        if (slides <= 1) {
            return;
        }

        var update = function(swiper) {
            //$element.find('.slider-counter').text((swiper.activeIndex + 1) + '/' + swiper.slides.length);

            //var caption = $(swiper.slides[swiper.activeIndex]).find('figcaption').html();
            //$element.find('.mediaslide__caption').html(caption);
        };

        var slider = new Swiper($element.find('.swiper-container')[0],
            {
                slidesPerView: 'auto',
                initialSlide: 0,
                navigation: {
                    nextEl: '.slider-next',
                    prevEl: '.slider-prev',
                },

                // cssMode: true,
                // swipeHandler:   string | HTMLElement

                // for better swipe / click
                resistance: true,
                resistanceRatio: 0.99,

                pagination: {
                    el: $element.find('.swiper-pagination')[0],
                    clickable: true,
                    dynamicBullets: true,
                    dynamicMainBullets: 3
                },

                on: {
                    init: function() {
                        update(this);
                        $element.find('.lazyloading').removeClass('lazyloading').addClass('lazyload');
                    },
                    slideChange: function() {
                        update(this);
                    }
                }
            });

    });

    // makes a distinct list of all images in the fancybox every time it is opened.
    var open = $.fancybox.open;
    $.fancybox.open = function(items, opts, index) {
        var inst = open(items, opts, index);
        if (inst) {
            var group = [], o = {};
            for (var i in inst.group) {
                var img = inst.group[i];
                if (!o[img.src]) {
                    o[img.src] = true;
                    group.push(img);
                }
            }

            // console.log('update group', inst.group, group);
            inst.group = group;
        }
        return inst;
    };

    $('[data-fancybox]').fancybox({
        caption: function(inst, item) {
            try {
                return $(this).parents('figure').find('figcaption').html();
            } catch (e) {
                console.error(e);
                return null;
            }
        }
    });

    var options = {
        animationEffect: "zoom", // "fade"
        transitionDuration: 550,

        preventCaptionOverlap: true,

        protect: true, // Disable right-click and use simple image protection for images

        media: {
            // ICDAM providers
            peer: {
                matcher: /https?:\/\/(player\.peer\.tv)\/(js)\/([0-9a-z]+)/i,
                type: "inline",
                url: function(match, params, item) {
                    var id = match[3];
                    var url = 'https://player.peer.tv/js/' +
                        id +
                        '/?w=liquid-proportional'; // + '&a=1'; <- to auto play
                    item.opts.smallBtn = false; // hide close btn
                    return '<div class="fancybox__peer-video"><script src="' + url + '"></script></div>';
                }
            },
            feratel: {
                matcher: /https?:\/\/(webtv\.feratel\.com)\/(webtv)\/?\?.*&cam=([0-9]+)/i,
                type: "iframe",
                url: 'https://webtv.feratel.com/webtv/?design=v3&cam=$3'
            },
            dailymotion: {
                matcher: /https?:\/\/(?:www\.)?(dailymotion\.com)\/video\/([^_]+)/i,
                type: "iframe",
                url: 'https://www.dailymotion.com/embed/video/$2?autoplay=1'
            },
            inetcons: { // obsolete
                matcher: /https?:\/\/(media\.inetcons\.it)\/(videos)\/(.+)\.(de|it|en)\.([0-9a-z]+)\.mp4/i,
                type: "iframe",
                url: 'https://media.inetcons.it/video/embed/$5?languageCode=$4&autoplay=true'
            },
            virtualSuedtirol: {
                matcher: /.*virtualsuedtirol\.com.*/i,
                type: 'iframe',
                url: '$0'
            },
            movingPictures: {
                matcher: /.*moving-pictures\.com.*/i,
                type: 'iframe',
                url: '$0'
            }
        },

        buttons: [
            "zoom",
            "share",
            "slideShow",
            //"fullScreen",
            //"download",
            "thumbs",
            "close"
        ],
        arrows: true,
        infobar: true, // window.innerWidth >= site.breakpoints.md.min, // on desktop
        thumbs: {autoStart: window.innerWidth >= site.breakpoints.md.min, // on desktop, // Display thumbnails on opening
            hideOnClose: true, // Hide thumbnail grid when closing animation starts
            parentEl: ".fancybox-container", // Container is injected into this element
            //axis: "x" // Vertical (y) or horizontal (x) scrolling
        },
        lang: site.language,
        i18n: {
            en: {
                CLOSE: "Close",
                NEXT: "Next",
                PREV: "Previous",
                ERROR: "The requested content cannot be loaded. <br/> Please try again later.",
                PLAY_START: "Start slideshow",
                PLAY_STOP: "Pause slideshow",
                FULL_SCREEN: "Full screen",
                THUMBS: "Thumbnails",
                DOWNLOAD: "Download",
                SHARE: "Share",
                ZOOM: "Zoom"
            },
            de: {
                CLOSE: "Schliessen",
                NEXT: "Weiter",
                PREV: "Zurück",
                ERROR: "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es später nochmal.",
                PLAY_START: "Diaschau starten",
                PLAY_STOP: "Diaschau beenden",
                FULL_SCREEN: "Vollbild",
                THUMBS: "Vorschaubilder",
                DOWNLOAD: "Herunterladen",
                SHARE: "Teilen",
                ZOOM: "Maßstab"
            },
            it: {
                CLOSE: "Chiudi",
                NEXT: "Avanti",
                PREV: "Indietro",
                ERROR: "Il contenuto richiesto non è disponibile. <br/> Si prega di riprovare più tardi.",
                PLAY_START: "Inizia presentazione",
                PLAY_STOP: "Ferma presentazione",
                FULL_SCREEN: "Schermo intero",
                THUMBS: "Anteprime",
                DOWNLOAD: "Scarica",
                SHARE: "Condividi",
                ZOOM: "Ingrandisci"
            }
        }
    };

    // set global options
    $.extend($.fancybox.defaults, options);

});